<template>
  <div class="TheNavbarDesktop">
    <TheNavbarLinks class="TheNavbarDesktop__links" :links="links" />

    <div class="TheNavbarDesktop__cta-actions">
      <UIButton
        :to="{ name: 'Contact' }"
        class="TheNavbarDesktop__cta-action"
        size="lg"
        theme="primary"
      >
        Get in touch
      </UIButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import UIButton from '../../../buttons/UIButton.vue'
import TheNavbarLinks from './TheNavbarLinks.vue'
import { INavbarItem } from '../TheNavbar.vue'

defineProps<{
  links: INavbarItem[]
}>()
</script>

<style lang="scss" scoped>
.TheNavbarDesktop {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .TheNavbarDesktop__links {
    margin: 0 3rem;
  }

  .TheNavbarDesktop__cta-actions {
    display: flex;
    gap: 0.75rem;
    margin-left: auto;
  }
}
</style>
